import type { VisioLink } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchAskVisio = async (
  kioskId: number,
  includeVideo: boolean,
  openingEventId?: number,
  signal?: AbortSignal,
) => {
  const res = await gozokiApiWithAuth.post<VisioLink>(
    `/visio/start/${kioskId}`,
    {
      includeVideo,
      openingEventId,
    },
    { signal },
  )
  return res.data
}
